import { createConsumer } from '@rails/actioncable'

// Create ActionCable consumer
// The consumer will connect to the WebSocket URL automatically
// Rails will handle authentication via session cookie
const consumer = createConsumer()

export default consumer
